import GroupLayer from '@arcgis/core/layers/GroupLayer';
import type { GISTimeLayer } from './TimeSlider.types';

export function toValidDate(value: unknown): Date | null {
  if (value == null) return null;
  const date = value instanceof Date ? value : new Date(value as number);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function extractExtent(
  fullTimeExtent: { start: unknown; end: unknown } | null | undefined,
): { start: Date; end: Date } | null {
  if (!fullTimeExtent) return null;
  const start = toValidDate(fullTimeExtent.start);
  const end = toValidDate(fullTimeExtent.end);
  if (!start || !end) return null;
  return { start, end };
}

export function isGroupLayer(layer: unknown): layer is GroupLayer {
  return layer != null && typeof layer === 'object' && 'layers' in layer;
}

/**
 * Finds the fullTimeExtent for a layer. Checks the layer itself first,
 * then falls back to child layers within a GroupLayer.
 */
export function findFullTimeExtent(
  gisLayer: GISTimeLayer | undefined,
): { start: Date; end: Date } | null {
  const directExtent = extractExtent(gisLayer?.timeInfo?.fullTimeExtent);
  if (directExtent) return directExtent;

  if (isGroupLayer(gisLayer)) {
    for (const child of gisLayer.layers.toArray()) {
      const childExtent = extractExtent(
        (child as GISTimeLayer).timeInfo?.fullTimeExtent,
      );
      if (childExtent) return childExtent;
    }
  }

  return null;
}
